import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, PayrollPeriod, PayrollPeriodCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreatePayrollPeriod(): UseMutationResult<
  AxiosResponse<PayrollPeriod>,
  AxiosError<ErrorMessage>,
  PayrollPeriodCreate
> {
  const queryClient = useQueryClient();

  const createPayrollPeriod = useCallback(
    (payrollPeriod: PayrollPeriodCreate): Promise<AxiosResponse<PayrollPeriod>> => {
      return client.post('payroll-periods/', payrollPeriod);
    },
    [],
  );
  return useMutation(createPayrollPeriod, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['payrollPeriods'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payrollEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['staffsPayout'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payroll'],
      });
    },
  });
}
